import { FormBuilder } from "components/FormBuilder/FormBuilder"
import React from 'react'
import { useTranslation } from "react-i18next";

/**
 * @param {Object} props 
 * @param {import("react-hook-form").UseFormReturn} props.formProps
 * @param {boolean} props.isCreate
 * @param {boolean} props.isEditing
 * @param {boolean} props.isLoading
 */
const OnlineMerchantManagementBankSection = ({
  formProps,
  isCreate,
  isEditing,
  isLoading
}) => {
  const { t: tLocal } = useTranslation("translation", { keyPrefix: "form.onlineMerchantManagement.merchant.bankSection" });
  const { t: tCommon } = useTranslation();

  const isDisabled = isLoading;
  const isReadOnly = !isCreate && !isEditing;

  /** @type {Record<string, import("components/FormBuilder/lib/FormBuilderFieldBuilder").formBuilderFieldConfig>} */
  const fieldsConfig = {
    bankAccount: {
      fieldType: "textInput",
      fieldName: "bankAccount",
      label: tLocal("label.bankAccount"),
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        rules: ["validBankAccount"]
      }
    },
    beneficiary: {
      fieldType: "textInput",
      fieldName: "beneficiary",
      label: tLocal("label.beneficiary"),
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        maxLength: 140,
        rules: ["onlyBlockLetter",
          "noLeadingWhitespace",
          "validBankBeneficiary",]
      }
    },
  }

  return (
    <FormBuilder.Section
      title={tLocal("title")}
      titleVariant="h3"
    >
      <FormBuilder.Row itemsPerRow={2}>
        {
          FormBuilder.buildFields({
            formProps,
            t: tCommon,
            fields: [
              fieldsConfig.bankAccount,
              fieldsConfig.beneficiary
            ]
          })
        }
      </FormBuilder.Row>
    </FormBuilder.Section>
  )
}

export default OnlineMerchantManagementBankSection